import {
  ColumnDetail,
  ComplexSelectionFormValue,
  RowDetail,
} from '../../../../../../../../ui/gzSelectableTableRowGroup/types';
import { Category, CategoryValue, Level } from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';

export const columns = (): ColumnDetail<Level>[] => {
  return [
    {
      column: Level.HIGH,
      label: translateFn('Aggressive'),
      tooltip: translateFn('Most objects are submitted to the Sandbox Analyzer, regardless of risk probability.'),
    },
    {
      column: Level.MEDIUM,
      label: translateFn('Normal'),
      tooltip: translateFn('A balance is maintained between submitted and ignored objects.'),
    },
    {
      column: Level.LOW,
      label: translateFn('Permissive'),
      tooltip: translateFn('Only high-risk objects are submitted to the Sandbox Analyzer, while the rest are ignored.'),
    },
  ];
};

export const rows = (): RowDetail<Category, Level>[] => [
  { key: Category.APPLICATIONS, label: translateFn('Applications') },
  { key: Category.DOCUMENTS, label: translateFn('Documents') },
  { key: Category.SCRIPTS, label: translateFn('Scripts') },
  { key: Category.ARCHIVES, label: translateFn('Archives') },
  { key: Category.EMAILS, label: translateFn('Emails') },
];

export function convertDbValueToFormValue(categories: { [key in Category]: CategoryValue }): ComplexSelectionFormValue<
  Category,
  Level
> {
  return Object.fromEntries(
    Object.entries(categories).map(([key, value]) => [
      key as Category,
      {
        enabled: value.enabled,
        column: value.level,
      },
    ])
  );
}

export function convertFormValueToDbValue(categories: ComplexSelectionFormValue<Category, Level>) {
  return Object.fromEntries(
    Object.entries(categories).map(([key, value]) => [
      key as Category,
      {
        enabled: value.enabled,
        level: value.column,
      },
    ])
  );
}
